import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { TranslateModule } from "@ngx-translate/core";
import { OnsipFormsModule } from "../../shared/components/forms/onsip-forms.module";
import { TableModule } from "@onsip/web/features/shared/components/table/onsip-table.module";
import { EditItemListModule } from "@onsip/web/features/shared/components/onsipItemList/edit-item-list.module";
import { SelectionListDeluxeModule } from "@onsip/web/features/shared/components/pickers/selectionListDeluxe/selection-list-deluxe.module";
import { FormEventTrackingModule } from "@onsip/web/features/shared/components/analytics/form-event-tracking.module";
import { AddressAutocompleteModule } from "../addressAutocomplete/address-autocomplete.module";
import { ListPickerModule } from "@onsip/web/features/shared/components/pickers/listPicker/list-picker.module";
import { ExternalPhoneNumberPageComponent } from "./externalPhoneNumberPage/external-phone-number-page.component";
import { ExternalPhoneNumberViewComponent } from "./externalPhoneNumberShelfView/external-phone-number-shelf-view.component";
import { ExternalPhoneNumberEditComponent } from "./externalPhoneNumberShelfEdit/external-phone-number-shelf-edit.component";
import { ExternalPhoneNumberSetupComponent } from "./externalPhoneNumberSetup/external-phone-number-setup.component";
import { ExternalPhoneNumberRoutingModule } from "./external-phone-number-routing.module";
import { ExtensionsListModule } from "@onsip/web/features/shared/components/extensionsList/extensions-list.module";
import { PhoneNumberListModule } from "../../shared/components/phoneNumberList/phone-number-list.module";
import { SipAddressFieldModule } from "../../shared/components/sipAddressField/sip-address-field.module";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { LayoutModule } from "@onsip/web/features/shared/components/layout/layout.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatSortModule } from "@angular/material/sort";
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatCardModule } from "@angular/material/card";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDividerModule } from "@angular/material/divider";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PipesModule,
    OnsipFormsModule,
    RouterModule,
    TableModule,
    EditItemListModule,
    SelectionListDeluxeModule,
    FormEventTrackingModule,
    AddressAutocompleteModule,
    ListPickerModule,
    ExternalPhoneNumberRoutingModule,
    SipAddressFieldModule,
    ExtensionsListModule,
    PhoneNumberListModule,
    TableDataLoadContainerModule,
    LayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSortModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatDividerModule,
    MatSelectModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTabsModule,
    MatSlideToggleModule,
    LoadingContainerComponent
  ],
  declarations: [
    ExternalPhoneNumberPageComponent,
    ExternalPhoneNumberViewComponent,
    ExternalPhoneNumberEditComponent,
    ExternalPhoneNumberSetupComponent
  ]
})
export class ExternalPhoneNumberModule {}
